module.exports = __webpack_public_path__ + "img/PSU_Logo.70cf4066.png";